import { render, staticRenderFns } from "./lifePercent.vue?vue&type=template&id=413fa17e&"
import script from "./lifePercent.vue?vue&type=script&lang=js&"
export * from "./lifePercent.vue?vue&type=script&lang=js&"
import style0 from "./lifePercent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports